<div class="note">
  <span>*Note: To build a Pump Schedule with advanced placement methods, please create the schedule in
    iCem and then import into VIDA.</span>
<br/>
  <span>*Temporary dialog </span> <span (click)="openMaterialAssignmentDialog()" class="custom-span">Material Assignments link</span> 

</div>
<div class="flx-ctn-row"
  [ngClass]="{'disable-form': (disabledOnControlPointState$ | async) || disabledOnJobState, 'disable-state': disabledOnJobState}">

  <div class="flx-itm-12-12 flx-itm-xs-12-12 flx-ctn-col p-t-20">
    <div class="flx-itm p-b-25 editing">
      <i class="glyphicon glyphicon-envelope custom-icon" aria-hidden="true"></i>
      <span (click)="sendMailReport()" class="custom-span">Report SAP Mismapping</span>
    </div>
    <shoetrack [listPumpScheduleStageStateManager$]="listPumpScheduleStageStateManager$"
      [scheduleState]="scheduleState"
      [namePumpSchedule]="getNamePumpSchedule"
      [isCmtSvc]="job.cmtSvc"
      [job]="job">
    </shoetrack>
  </div>
  <div class="flx-itm-12-12 flx-itm-xs-12-12 flx-ctn-col p-t-20 p-r-20 pump-stages">
    <div class="center-tabs"> 
      <p-tabs *ngIf="(isAddPumpScheduleVisible$ | async)"
               [class]="'ui-tab-view-md p-tab-view-lg pump-schedule-tab-view ' + getButtonAddClass()"
               [ngClass]="{ 'tabs-more-than-12': tabs >= 12, 'tabs-less-than-12': tabs < 12 }"
               [(value)]="selectedTab" (valueChange)="onTabChange($event)">
        <p-tablist>
          <ng-container *ngFor="let pumpScheduleTabview of (listPumpScheduleStageStateManager$ | async)">
            <p-tab [value]="pumpScheduleTabview.index">
              <div class="p-3 pump-name-container" [title]="pumpScheduleTabview.displayText"
                   *ngIf="!pumpScheduleTabview.isHidden">
                <div class="pump-schedule-name" contenteditable="false">
                  {{pumpScheduleTabview.displayText}}
                </div>
                <span *ngIf="pumpScheduleTabview.index === selectedTab && enabledDeletePumpScheduleState"
                      class='pump-tab-delete-btn' (click)="showPumpScheduleOption(pumpScheduleTabview, pumpOption, $event)">
                  <i class="pi pi-ellipsis-v"></i>
                </span>
              </div>
            </p-tab>
          </ng-container>
        </p-tablist>
      </p-tabs>

      <div>
        <stage class="stage-view" *ngFor="let stageState of (stagesStates$ | async) as stageStateNodes;let indexOfStage=index;"
               [stageState]="stageState" [refreshForm]="refreshForm"
               [slurryData]="slurryData"
               [index]="indexOfStage"
               [isPumpDefault]="selectedTab === 0"
               [job]="job"
               (onStageAlign)="onStageAlign($event)"></stage>
      </div>
      <div class="tabview-add-new"
           *ngIf="pumpScheduleStageStateManager.length < 12 && (isAddPumpScheduleVisible$ | async) && (enabledAddPumpScheduleState$ | async)"
           class="tabview-add-new" (click)="addPumpScheduleBtnOnClicked()">
        <i class="fa fa-plus-circle"></i> Add Pump Schedule
      </div>
    </div>
  </div>
</div>
<p-menu #pumpOption [popup]="true" [model]="pumpScheduleOptions" appendTo="body" baseZIndex="100000000"></p-menu>
